import { Component, OnInit, Input, style, trigger, animate, transition } from '@angular/core';
import { OrganizationalReportService } from './../organizational-report.service';
import { SessionStorage } from 'ngx-webstorage';
import { EmployeeList, EmployeeProject } from '../organizational-report';

@Component({
  selector: 'app-report-hierarchy',
  templateUrl: './report-hierarchy.component.html',
  styleUrls: ['./report-hierarchy.component.css'],
  animations: [
    trigger(
      'enterAnimation', [
        transition(':enter', [
          style({ opacity: 0 }),
          animate('500ms ease-in', style({ opacity: 1 }))
        ])
      ]
    )
  ]
})

export class ReportHierarchyComponent implements OnInit {
  // tslint:disable-next-line:no-input-rename
  @Input('employee') childData: Array<Object>;
  @SessionStorage() public user;

  public showActivity = false;
  public startDate: any = '';
  public endDate: any = '';
  public employee = [];
  constructor(
    public reportService: OrganizationalReportService
  ) { }

  ngOnInit() {
    this.getDateStatus();
    this.checkEmployee();
  }

  /**function to checkEmployee heirarchy */
  checkEmployee() {
  this.employee = [];
    this.childData.forEach(value => {
      this.employee.push(new EmployeeList(value));
    });
  }

  /**function to get employee */
  getEmployee(employeeDetails, event) {
    if (employeeDetails.showEmployee === false) {
      employeeDetails.employees = [];
      for (let i = 0; i < this.employee.length; i++) {
        if (!!this.employee[i]) {
          this.employee[i].showEmployee = false;
          this.employee[i].showProject = false;
        }
      }
      employeeDetails.showEmployee = true;
      this.reportService.getEmployee(employeeDetails.empNo).subscribe(
        (data) => {
          if (data.payload) {
            data.payload.forEach(value => {
              employeeDetails.employees.push(value);
            });
          }
        });
    } else {
      employeeDetails.showEmployee = false;
    }
  }

  /**function to get project details */
  getProject(employeeDetails) {
    if (employeeDetails.showProject === false) {
      this.getDateStatus();
      employeeDetails.projects = [];
      for (let i = 0; i < this.employee.length; i++) {
        if (!!this.employee[i]) {
          this.employee[i].showProject = false;
          this.employee[i].showEmployee = false;
        }
      }
      employeeDetails.showProject = true;
      if (!this.startDate || !this.endDate) {
        this.startDate = '';
        this.endDate = '';
      }
      this.reportService.getEmployeeProject(employeeDetails.empNo, this.startDate, this.endDate).subscribe(
        (data) => {
          if (data.payload) {
            if (data.payload) {
              data.payload.forEach(value => {
                employeeDetails.projects.push(new EmployeeProject(value));
              });
            }
          }
        });
    } else {
      employeeDetails.showProject = false;
    }
  }

  /**function to get project activity*/
  showProjectActivities(project) {
    for (let i = 0; i < this.employee.length; i++) {
      if (!!this.employee[i].projects) {
        this.employee[i].projects.forEach(element => {
          element.showActivity = false;
        });
      }
    }
    project.showActivity = true;
  }

  /**function to hide and show project*/
  hideProjectActivities(project) {
    project.showActivity = false;
  }

  /**function to set start and end Date*/
  setDateFilter( start, end) {
    this.startDate = start;
    this.endDate = end;
    if (this.startDate && this.endDate) {
      this.checkEmployee();
    } else if (!this.startDate && !this.endDate) {
      this.checkEmployee();
    }

  }

  /**function to get date status*/
  getDateStatus() {
    this.reportService.getDateStatus().subscribe(data => {
      if (data) {
        this.startDate = data.startDate;
        this.endDate = data.endDate;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/rm/organizational-report/report-hierarchy/report-hierarchy.component.ts